import React, { useEffect, useRef } from 'react';
import './SectionBackgroundVideo.css';

const SectionBackgroundVideo = ({
  webm,
  mp4,
  poster,
  className = '',
  objectPosition,
  zoom = 1,
  objectPositionMobile,
  zoomMobile,
}) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    const playPromise = video.play();

    if (playPromise?.catch) {
      playPromise.catch(() => {
        // Safari/iOS may block autoplay, especially in Low Power Mode.
      });
    }
  }, []);

  const style = {};
  if (objectPosition) style['--sbv-position'] = objectPosition;
  if (zoom && zoom !== 1) style['--sbv-zoom'] = zoom;
  if (objectPositionMobile) style['--sbv-position-mobile'] = objectPositionMobile;
  if (zoomMobile != null) style['--sbv-zoom-mobile'] = zoomMobile;

  return (
    <video
      ref={videoRef}
      className={`section-bg-video ${className}`.trim()}
      autoPlay
      loop
      muted
      defaultMuted
      playsInline
      webkit-playsinline='true'
      preload='auto'
      poster={poster}
      aria-hidden='true'
      style={Object.keys(style).length ? style : undefined}
    >
      {mp4 && <source src={mp4} type='video/mp4' />}
      {webm && <source src={webm} type='video/webm' />}
    </video>
  );
};

export default SectionBackgroundVideo;
